import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import PlayerAvatar from "@topaasia/player-avatar";

import "./card-game-note-list-item.scss";

const CardGameNoteListItem = ({ gameNote }) => {
  const { t } = useTranslation("views");
  const { player } = gameNote;
  // The avatar is decorative: name the note's author for screen readers.
  const author = player ? player.name : t("game-note.game-master");

  return (
    <div className="card-game-note-list-item">
      {player ? (
        <PlayerAvatar size={40} type={player.avatar} playerColor={player.color} />
      ) : (
        <PlayerAvatar size={40} />
      )}
      <span className="game-note-message">
        <span className="visually-hidden">{`${author}: `}</span>
        {gameNote.text}
      </span>
    </div>
  );
};

CardGameNoteListItem.propTypes = {
  gameNote: PropTypes.shape({
    player: PropTypes.object,
    text: PropTypes.string.isRequired,
  }).isRequired,
};

export default CardGameNoteListItem;
